module.exports = __webpack_public_path__ + "static/media/virtual-events-video.56b2f430.mp4";